<template>
	<div>
		<!-- Classificação de Carga -->
		<div class="row">
			<div class="col-xs-12 form-group" :class="{'has-error': erro.classificacao != ''}">
				<label><span class="no-print">* </span>{{ _traducao('global', 'classificacao') }}:</label>
				<select v-model.trim="form.classificacao" class="form-control input-sm">
					<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
					<option value="LIQUIDA">Líquida</option>
					<option value="PERIGOSA">Perigosa</option>
					<option value="OUTRAS">Outras</option>
				</select>
				<p class="help-block" v-show="erro.classificacao != ''">{{ erro.classificacao }}</p>
			</div>

			<div class="col-xs-12 form-group" :class="{'has-error': erro.sigla != ''}">
				<label><span class="no-print">* </span>{{ _traducao('global', 'sigla') }}</label>
				<input type="text" v-model="form.sigla" class="form-control input-sm" />
				<p class="help-block" v-show="erro.sigla != ''">{{ erro.sigla }}</p>
			</div>

			<div class="col-xs-12 form-group" :class="{'has-error': erro.descricao != ''}">
				<label><span class="no-print">* </span>{{ _traducao('global', 'descricao') }}</label>
				<input type="text" v-model="form.descricao" class="form-control input-sm" />
				<p class="help-block" v-show="erro.descricao != ''">{{ erro.descricao }}</p>
			</div>

			<div class="col-xs-12 form-group">
				<label>{{ _traducao('global', 'detalhar') }}</label> <br />
				<div class="btn-group print-button-group" role="group">
					<button
						type="button"
						@click="form.detalhar = 1"
						:class="{'btn-info': form.detalhar == 1}"
						class="btn btn-default btn-sm"
					>
						{{ _traducao('global', 'sim') }}
					</button>
					<button
						type="button"
						@click="form.detalhar = 0"
						:class="{'btn-info': form.detalhar == 0}"
						class="btn btn-default btn-sm"
					>
						{{ _traducao('global', 'nao') }}
					</button>
				</div>
			</div>
		</div>

		<!-- Botao salvar -->
		<div class="row">
			<div class="col-xs-12">
				<span class="label label-info pull-left no-print">
					<i class="fa fa-info-circle"></i> {{ _traducao('global', 'obrigatorio') }}
				</span>

				<button type="button" @click="salvar" class="btn btn-success pull-right">
					<i class="fa fa-check" aria-hidden="true"></i> {{ _traducao('global', 'salvar').toUpperCase() }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			id_usuario: Number(window.$sessao.getId()),
			form: {
				id: 0,
				classificacao: '',
				sigla: '',
				descricao: '',
				detalhar: 0
			},
			erro: {
				classificacao: '',
				sigla: '',
				descricao: ''
			}
		}
	},
	methods: {
		limparTodasChavesNoObjeto(objeto) {
			const regexParaApenasNumeros = /^[0-9]+$/g

			Object.keys(objeto).forEach((chave) => {
				objeto[chave] = regexParaApenasNumeros.test(objeto[chave]) ? 0 : ''
			})
		},

		limparDados() {
			this.limparTodasChavesNoObjeto(this.form)
			this.limparTodasChavesNoObjeto(this.erro)
		},

		validarFormulario() {
			let passou = true
			const obrigatorio = this._traducao('global', 'campoObrigatorio')

			if (this.form.descricao === '') {
				this.erro.descricao = obrigatorio
				passou = false
			} else {
				this.erro.descricao = ''
			}

			if (this.form.classificacao === '') {
				this.erro.classificacao = obrigatorio
				passou = false
			} else {
				this.erro.classificacao = ''
			}

			if (this.form.sigla === '') {
				this.erro.sigla = obrigatorio
				passou = false
			} else {
				this.erro.sigla = ''
			}

			return passou
		},

		removerValorEmObjetoPorChave(objeto, chaves) {
			let novoObjeto = {}

			for (let chave in objeto) {
				if (!chaves.includes(chave)) {
					novoObjeto = Object.assign(novoObjeto, {
						[chave]: this.form[chave]
					})
				}
			}

			return novoObjeto
		},

		salvar() {
			if (this.validarFormulario()) {
				window.bus.$emit('load-in', {text: this._traducao('global', 'salvando')})

				const tipo_carga = this.removerValorEmObjetoPorChave(this.form, ['_index', '_exibir'])
				const data = {
					id_usuario: this.id_usuario,
					tipo_carga
				}

				this._httpPost('/Tipo_carga/salvar', data, (retorno) => {
					window.bus.$emit('load-out')

					if (retorno._request) {
						window.bus.$emit('exibir-notificacao', {type: 'success', text: this._traducao('global', 'cargaSalvaComSucesso')})
						this.$emit('tipo-carga-salvo', retorno)
					} else {
						window.bus.$emit('exibir-notificacao', {type: 'danger', text: this._traducao('global', 'houveUmErroAoTentarSalvar')})
					}
				})
			} else {
				window.bus.$emit('exibir-notificacao', {type: 'danger', text: this._traducao('global', 'corrijaCamposVermelho')})
			}
		}
	}
}
</script>